// extracted by mini-css-extract-plugin
module.exports = {"video-container":"VideoGroup_video-container__fNgH_","video-info":"VideoGroup_video-info__d8zuI"};